import { Component, defineAsyncComponent, h } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { MenuDataItem } from './typing';
import Layout from '@/layouts/index.vue';
// import UserLayout from '@/layouts/user-layout.vue';
import UserLayout2 from '@/layouts/user-layout2.vue';
import OtherLayout from '@/layouts/other-layout.vue';
import RouteView from '@/layouts/route-view.vue';
import RouteView2 from '@/layouts/route-view2.vue';

const basic = defineAsyncComponent(() => import('@/views/profile/basic/index.vue'));
const franchisee = defineAsyncComponent(() => import('@/views/profile/basic-franchisee/index.vue'));
const basic_order = defineAsyncComponent(() => import('@/views/profile/basic_order/index.vue'));
const page_model = defineAsyncComponent(() => import('@/components/page-model/index.vue'));
const logRecordInfoPage = defineAsyncComponent(() => import('@/views/logRecordInfo/index.vue'));

const mubiao = defineAsyncComponent(() => import('@/views/month-target/index.vue'));
export const routes: MenuDataItem[] = [
  {
    name: 'index',
    path: '/',
    redirect: '/workplace',
    component: Layout,
    children: [
      // dashboard
      // {
      //   path: '/workplace',
      //   name: 'Workplace',
      //   meta: { icon: '', title: '美丽报告'  },
      //   component: h(RouteView, {}, () => h(AsyncWorkplace)),
      // },
      {
        path: '/operation_manage',
        name: 'operation_manage',
        meta: { title: '运营管理', authority: 'operation_manage', icon: 'DeploymentUnitOutlined' },
        component: RouteView2,
        redirect: '/operation_manage/month-target',
        children: [
          {
            path: '/operation_manage/month-target',
            name: 'month-target',
            meta: { title: '目标设定', authority: 'operation_manage/month-target' },
            component: h(RouteView, {}, () => h(mubiao)),
          },
          {
            path: '/operation_manage/mjstore-target_setting',
            name: 'mjstat-shop_operation_target',
            meta: { title: '目标设定', authority: 'operation_manage/mjstore-target_setting' },
            component: RouteView2,
            redirect: '/operation_manage/mjstat-shop_operation_target',
            children: [
              {
                path: '/operation_manage/mjstat-shop_operation_target',
                name: 'mjstore-shop_operation_target',
                meta: {
                  title: '店务运营目标',
                  authority: 'operation_manage/mjstat-shop_operation_target',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/mjstat-staff_operation_target',
                name: 'mjstat-staff_operation_target',
                meta: {
                  title: '客户运营目标',
                  authority: 'operation_manage/mjstat-staff_operation_target',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
            ],
          },
          {
            path: '/operation_manage/mjstat-shop_operation_daily_report',
            name: 'mjstat-shop_operation_daily_report',
            meta: {
              title: '店务运营日报表',
              authority: 'operation_manage/mjstat-shop_operation_daily_report',
            },
            component: h(RouteView, {}, () => h(page_model)),
          },
          {
            path: '/operation_manage/mjstat-customer_operation_daily_report',
            name: 'mjstat-customer_operation_daily_report',
            meta: {
              title: '客户运营日报表',
              authority: 'operation_manage/mjstat-customer_operation_daily_report',
            },
            component: h(RouteView, {}, () => h(page_model)),
          },
          {
            path: '/operation_manage/mjstore-customer_list_with_customer_type',
            name: 'mjstore-customer_list_with_customer_type',
            meta: {
              title: '客户转化列表',
              authority: 'operation_manage/mjstore-customer_list_with_customer_type',
            },
            component: h(RouteView, {}, () => h(page_model)),
          },
          {
            path: '/operation_manage/mjstore-customer_activation_active',
            name: 'mjstore-customer_activation_active',
            meta: {
              title: '客户激活列表',
              authority: 'operation_manage/mjstore-customer_activation_active',
            },
            component: h(RouteView, {}, () => h(page_model)),
          },
          {
            path: '/business_manage/mjstore-customer_activation_change',
            name: 'mjstore-customer_activation_change',
            meta: {
              title: '客户活跃列表',
              authority: 'operation_manage/mjstore-customer_activation_change',
            },
            component: h(RouteView, {}, () => h(page_model)),
          },
          // {
          //   path: '/operation_manage/mjstore-customer_convert_daily_report',
          //   name: 'mjstore-appointment',
          //   meta: { title: '客户转化日报表', authority: 'business_manage/mjstore-customer_convert_daily_report' },
          //   component: h(RouteView, {}, () => h(page_model)),
          // },
          // {
          //   path: '/operation_manage/mjstore-customer_activate_daily_report',
          //   name: 'mjstore-appointment',
          //   meta: { title: '客户激活日报表', authority: 'business_manage/mjstore-customer_active_daily_report' },
          //   component: h(RouteView, {}, () => h(page_model)),
          // },
          // {
          //   path: '/operation_manage/mjstore-appointment',
          //   name: 'mjstore-appointment',
          //   meta: { title: '客户活跃日报表', authority: 'business_manage/mjstore-customer_activity_daily_report' },
          //   component: h(RouteView, {}, () => h(page_model)),
          // },
          {
            path: '/business_manage/mjstore-appointment',
            name: 'mjstore-appointment',
            meta: { title: '预约管理', authority: 'business_manage/mjstore-appointment' },
            component: h(RouteView, {}, () => h(page_model)),
          },
          {
            path: '/operation_manage/mjstore-baseinfo-manage',
            name: 'mjstore-baseinfo-manage',
            meta: { title: '档案管理', authority: 'operation_manage/mjstore-baseinfo-manage' },
            component: RouteView2,
            redirect: '/operation_manage/mjstore-baseinfo',
            children: [
              {
                path: '/operation_manage/mjstore-baseinfo/mjstore-baseinfo',
                name: 'mjstore-baseinfo',
                meta: {
                  title: '基础档案',
                  authority: 'operation_manage/mjstore-baseinfo/mjstore-baseinfo',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/mjstore-baseinfo/mjstore-requireinfo',
                name: 'mjstore-requireinfo',
                meta: {
                  title: '解决方案',
                  authority: 'operation_manage/mjstore-baseinfo/mjstore-requireinfo',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/mjstore-baseinfo/mjstore-servicedetail',
                name: 'mjstore-servicedetail',
                meta: {
                  title: '服务过程',
                  authority: 'operation_manage/mjstore-baseinfo/mjstore-servicedetail',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/mjstore-baseinfo/mjstore-postsale',
                name: 'mjstore-postsale',
                meta: {
                  title: '产品跟进',
                  authority: 'operation_manage/mjstore-baseinfo/mjstore-postsale',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/mjstore-baseinfo/mjstore-planinfo',
                name: 'mjstore-planinfo',
                meta: {
                  title: '计划安排',
                  authority: 'operation_manage/mjstore-baseinfo/mjstore-planinfo',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/mjstore-baseinfo/mjstore-feedbackinfo',
                name: 'mjstore-feedbackinfo',
                meta: {
                  title: '回访情况',
                  authority: 'operation_manage/mjstore-baseinfo/mjstore-feedbackinfo',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
            ],
          },
          {
            path: '/operation_manage/operation_status',
            name: 'operation_status',
            meta: { title: '运营状态', authority: 'operation_manage/operation_status' },
            component: RouteView2,
            redirect: '/operation_manage/operation_status/mjstore-gradechangerecord',
            children: [
              {
                path: '/operation_manage/operation_status/mjstore-gradechangerecord',
                name: 'mjstore-gradechangerecord',
                meta: {
                  title: '客户等级记录表',
                  authority: 'operation_manage/operation_status/mjstore-gradechangerecord',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/operation_status/mjstore-customershopchangerecord',
                name: 'mjstore-customershopchangerecord',
                meta: {
                  title: '会员会籍记录表',
                  authority: 'operation_manage/operation_status/mjstore-customershopchangerecord',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/operation_status/mjstore-staffserverecord',
                name: 'mjstore-staffserverecord',
                meta: {
                  title: '员工状态记录表',
                  authority: 'operation_manage/operation_status/mjstore-staffserverecord',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/operation_status/mjstore-bedchangerecord',
                name: 'mjstore-bedchangerecord',
                meta: {
                  title: '床位状态记录表',
                  authority: 'operation_manage/operation_status/mjstore-bedchangerecord',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/operation_status/mjstore-customer_list_with_customer_type_record',
                name: 'mjstore-customer_list_with_customer_type_record',
                meta: {
                  title: '客户转化记录表',
                  authority:
                    'operation_manage/operation_status/mjstore-customer_list_with_customer_type_record',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/operation_status/mjstore-customer_activation_event_record',
                name: 'mjstore-customer_activation_event_record',
                meta: {
                  title: '客户活动记录表',
                  authority:
                    'operation_manage/operation_status/mjstore-customer_activation_event_record',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/operation_status/mjstore-customer_activation_change_record',
                name: 'mjstore-customer_activation_change_record',
                meta: {
                  title: '客户活跃记录表',
                  authority:
                    'operation_manage/operation_status/mjstore-customer_activation_change_record',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
            ],
          },
          {
            path: '/operation_manage/data_query',
            name: 'data_query',
            meta: { title: '信息查询', authority: 'operation_manage/data_query' },
            component: RouteView2,
            redirect: '/operation_manage/data_query/mjstat-customerremainmoney',
            children: [
              {
                path: '/operation_manage/data_query/mjstat-customerremainmoney',
                name: 'mjstat-customerremainmoney',
                meta: {
                  title: '余额余项额',
                  authority: 'operation_manage/data_query/mjstat-customerremainmoney',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/operation_manage/data_query/mjstat-customerremainliang',
                name: 'mjstat-customerremainliang',
                meta: {
                  title: '余额余项量',
                  authority: 'operation_manage/data_query/mjstat-customerremainliang',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/log_app/log_app-logsubject',
                name: 'log_app-logsubject',
                meta: {
                  title: '日志列表',
                  authority: 'log_app/log_app-logsubject',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/log_app/log_app-logrecord',
                name: 'log_app-logrecord',
                meta: {
                  title: '日志记录',
                  authority: 'log_app/log_app-logrecord',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/log_app/log_app-loginfo/:request_id/:create_time',
                name: 'log_app-loginfo',
                meta: { title: '日志详情', hideInMenu: true },
                component: h(RouteView, {}, () => h(logRecordInfoPage)),
              },
            ],
          },
        ],
      },
      {
        path: '/business_manage',
        name: 'business_manage',
        meta: { title: '业务管理', authority: 'business_manage', icon: 'NotificationOutlined' },
        component: RouteView2,
        redirect: '/business_manage/mjstore_shop_status',
        children: [
          {
            path: '/business_manage/mjstore_shop_status',
            name: 'mjstore_shop_status',
            meta: { title: '门店管理', authority: 'business_manage/mjstore_shop_status' },
            component: RouteView2,
            redirect: '/business_manage/mjstore-customer',
            children: [
              {
                path: '/business_manage/mjstore-customer',
                name: 'mjstore-customer',
                meta: { title: '新客', authority: 'business_manage/mjstore-customer' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-czrecord',
                name: 'mjstore-czrecord',
                meta: { title: '充值', authority: 'business_manage/mjstore-czrecord' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-orderrecord',
                name: 'mjstore-orderrecord',
                meta: { title: '下单', authority: 'business_manage/mjstore-orderrecord' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-cardrecord',
                name: 'mjstore-cardrecord',
                meta: { title: '购卡', authority: 'business_manage/mjstore-cardrecord' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-setrecord',
                name: 'mjstore-setrecord',
                meta: { title: '套餐', authority: 'business_manage/mjstore-setrecord' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-orderremove',
                name: 'mjstore-orderremove',
                meta: { title: '撤单', authority: 'business_manage/mjstore-orderremove' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-cardremove',
                name: 'mjstore-cardremove',
                meta: { title: '撤卡', authority: 'business_manage/mjstore-cardremove' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-orderrecordcard',
                name: 'mjstore-orderrecordcard',
                meta: { title: '卡转单', authority: 'business_manage/mjstore-orderrecordcard' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-kzkcardrecord',
                name: 'mjstore-kzkcardrecord',
                meta: { title: '卡转卡', authority: 'business_manage/mjstore-kzkcardrecord' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-changeorder',
                name: 'mjstore-changeorder',
                meta: { title: '换单', authority: 'business_manage/mjstore-changeorder' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-orderusedrecord',
                name: 'mjstore-orderusedrecord',
                meta: { title: '耗单', authority: 'business_manage/mjstore-orderusedrecord' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-orderusedcancelrecord',
                name: 'mjstore-orderusedcancelrecord',
                meta: {
                  title: '销售退货',
                  authority: 'business_manage/mjstore-orderusedcancelrecord',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
            ],
          },
          {
            path: '/business_manage/mjstore_jms_status',
            name: 'mjstore_jms_status',
            meta: { title: '加盟管理', authority: 'business_manage/mjstore_jms_status' },
            component: RouteView2,
            redirect: 'business_manage/mjstore_jms_status/company-franchiseeczrecord',
            children: [
              {
                path: '/business_manage/mjstore_jms_status/company-franchiseeczrecord',
                name: 'company-franchiseeczrecord',
                meta: {
                  title: '收款',
                  authority: 'business_manage/mjstore_jms_status/company-franchiseeczrecord',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore_jms_status/company-requestorder',
                name: 'company-requestorder',
                meta: {
                  title: '报单',
                  authority: 'business_manage/mjstore_jms_status/company-requestorder',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore_jms_status/company-productorder',
                name: 'company-productorder',
                meta: {
                  title: '下单',
                  authority: 'business_manage/mjstore_jms_status/company-productorder',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore_jms_status/company-sendorder',
                name: 'company-sendorder',
                meta: {
                  title: '发货',
                  authority: 'business_manage/mjstore_jms_status/company-sendorder',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore_jms_status/company-backorder',
                name: 'company-backorder',
                meta: {
                  title: '撤单',
                  authority: 'business_manage/mjstore_jms_status/company-backorder',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_company/jms-companystaff',
                name: 'jms-companystaff',
                meta: {
                  title: '公司员工',
                  authority: 'mjstore_company/jms-companystaff',
                  hideInMenu: true,
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
            ],
          },
          {
            path: '/business_manage/mjstore_franchisee',
            name: 'mjstore_franchisee',
            meta: { title: '*加盟管理', authority: 'business_manage/mjstore_franchisee' },
            component: RouteView2,
            redirect: 'mjstore_franchisee/jms-franchiseeczrecord',
            children: [
              {
                path: '/mjstore_franchisee/jms-franchiseeczrecord',
                name: 'jms-franchiseeczrecord',
                meta: { title: '收款', authority: 'mjstore_franchisee/jms-franchiseeczrecord' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_franchisee/jms-requestorder',
                name: 'jms-requestorder',
                meta: { title: '报单', authority: 'mjstore_franchisee/jms-requestorder' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_franchisee/jms-productorder',
                name: 'jms-productorder',
                meta: { title: '下单', authority: 'mjstore_franchisee/jms-productorder' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_franchisee/jms-sendorder',
                name: 'jms-sendorder',
                meta: { title: '发货', authority: 'mjstore_franchisee/jms-sendorder' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_franchisee/jms-backorder',
                name: 'jms-backorder',
                meta: { title: '撤单', authority: 'mjstore_franchisee/jms-backorder' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_franchisee/jms-franchiseewallet',
                name: 'jms-franchiseewallet',
                meta: {
                  title: '加盟商钱包',
                  authority: 'mjstore_franchisee/jms-franchiseewallet',
                  hideInMenu: true,
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
            ],
          },
        ],
      },
      {
        path: '/mjstock',
        name: 'mjstock',
        meta: { title: '库存管理', authority: 'mjstock', icon: 'GatewayOutlined' },
        component: RouteView2,
        redirect: '/mjstock/caigou/mjstock-productinrecord1',
        children: [
          {
            path: '/mjstock/caigou/mjstock-productinrecord1',
            name: 'mjstock-productinrecord1',
            meta: { title: '入库', authority: 'mjstock/caigou/mjstock-productinrecord1' },
            // redirect: '/mjstock/caigou/mjstock-productinrecord1',
            component: h(RouteView, {}, () => h(page_model)),
          },
          {
            path: '/mjstock/xiaoshou/mjstock-productoutrecord1',
            name: 'mjstock-productoutrecord1',
            meta: { title: '出库', authority: 'mjstock/xiaoshou/mjstock-productoutrecord1' },
            component: h(RouteView, {}, () => h(page_model)),
          },
          {
            path: '/mjstock/mjstock-productincancelrecord',
            name: 'mjstock-productincancelrecord',
            meta: { title: '入库退货', authority: 'mjstock/mjstock-productincancelrecord' },
            component: h(RouteView, {}, () => h(page_model)),
          },
          {
            path: '/mjstock/mjstock-productoutcancelrecord',
            name: 'mjstock-productoutcancelrecord',
            meta: { title: '出库退货', authority: 'mjstock/mjstock-productoutcancelrecord' },
            component: h(RouteView, {}, () => h(page_model)),
          },
        ],
      },
      {
        name: '权限管理',
        path: '/permission',
        meta: { title: '权限管理', authority: 'permission', icon: 'KeyOutlined' },
        component: RouteView,
        redirect: '/permission/auth-manage',
        children: [
          {
            path: '/permission/menu-manage',
            name: 'menu-manage',
            meta: { title: '菜单', authority: 'permission/menu-manage' },
            component: (): Component => import('@/views/permission/menu-manage/index.vue'),
          },
          {
            path: '/permission/auth-manage',
            name: 'auth-manage',
            meta: { title: '角色', authority: 'permission/auth-manage' },
            component: (): Component => import('@/views/permission/auth-manage/index.vue'),
          },
          {
            path: '/permission/user-manage',
            name: 'user-manage',
            meta: { title: '用户', authority: 'permission/user-manage' },
            component: (): Component => import('@/views/permission/user-manage/index.vue'),
          },

          // {
          //   path: '/permission/role-manage',
          //   name: 'role-manage',
          //   meta: { title: '角色管理', authority: 'permission/role-manage' },
          //   component: (): Component => import('@/views/permission/role-manage/index.vue'),
          // },
        ],
      },
      {
        path: '/mjstore_baseinfo',
        name: 'mjstore_baseinfo',
        meta: { title: '基础信息', authority: 'mjstore_baseinfo', icon: 'SettingOutlined' },
        component: RouteView2,
        redirect: '/mjstore_baseinfo/mjstore_beautiful_report',
        children: [
          {
            path: '/mjstore_baseinfo/mjstore_beautiful_report',
            name: 'mjstore_beautiful_report',
            meta: { title: '美丽报告', authority: 'mjstore_baseinfo/mjstore_beautiful_report' },
            component: RouteView2,
            redirect: '/business_manage/mjstore-shoptype',
            children: [
              {
                path: '/mjstore_baseinfo/mjstore-shoptype',
                name: 'mjstore-shoptype',
                meta: { title: '板块管理', authority: 'mjstore_baseinfo/mjstore-shoptype' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstore-area',
                name: 'mjstore-area',
                meta: { title: '片区管理', authority: 'mjstore_baseinfo/mjstore-area' },
                component: h(RouteView, {}, () => h(page_model)),
              },
            ],
          },
          {
            path: '/mjstore_baseinfo/mjstore_business_status',
            name: 'mjstore_business_status',
            meta: { title: '业务管理', authority: 'mjstore_baseinfo/mjstore_business_status' },
            component: RouteView2,
            redirect: '/business_manage/mjstore-shop',
            children: [
              {
                path: '/mjstore_baseinfo/mjstore-shop',
                name: 'mjstore-shop',
                meta: { title: '门店设置', authority: 'mjstore_baseinfo/mjstore-shop' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstore-staff_title',
                name: 'mjstore-staff_title',
                meta: { title: '职位设置', authority: 'mjstore_baseinfo/mjstore-staff_title' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstore-staff',
                name: 'mjstore-staff',
                meta: { title: '员工管理', authority: 'mjstore_baseinfo/mjstore-staff' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstore-customer1',
                name: 'mjstore-customer1',
                meta: { title: '客户管理', authority: 'mjstore_baseinfo/mjstore-customer1' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstore-customertype',
                name: 'mjstore-customertype',
                meta: { title: '客户类型', authority: 'mjstore_baseinfo/mjstore-customertype' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstore-grade',
                name: 'mjstore-grade',
                meta: { title: '会员等级', authority: 'mjstore_baseinfo/mjstore-grade' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstore-customeractivation',
                name: 'mjstore-customeractivation',
                meta: {
                  title: '活跃类型',
                  authority: 'mjstore_baseinfo/mjstore-customeractivation',
                },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo2/mjstore-projecttype',
                name: 'mjstore-projecttype',
                meta: { title: '项目类别', authority: 'mjstore_baseinfo2/mjstore-projecttype' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo2/mjstore-project',
                name: 'mjstore-project',
                meta: { title: '下单管理', authority: 'mjstore_baseinfo2/mjstore-project' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo2/mjstore-card',
                name: 'mjstore-card',
                meta: { title: '购卡管理', authority: 'mjstore_baseinfo2/mjstore-card' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo2/mjstore-projectset',
                name: 'mjstore-projectset',
                meta: { title: '套餐管理', authority: 'mjstore_baseinfo2/mjstore-projectset' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/business_manage/mjstore-bed',
                name: 'mjstore-bed',
                meta: { title: '床位管理', authority: 'business_manage/mjstore-bed' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/pricechangerecord',
                name: 'pricechangerecord',
                meta: { title: '价格变动记录表', authority: 'mjstore_baseinfo/pricechangerecord' },
                component: (): Component => import('@/views/pricechange/index.vue'),
              },
              {
                path: '/mjstore_baseinfo/mjstore-sktype',
                name: 'mjstore-sktype',
                meta: { title: '支付方式', authority: 'mjstore_baseinfo/mjstore-sktype' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstore-hktype',
                name: 'mjstore-hktype',
                meta: { title: '获客方式', authority: 'mjstore_baseinfo/mjstore-hktype' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstore-policy',
                name: 'mjstore-policy',
                meta: { title: '促销政策', authority: 'mjstore_baseinfo/mjstore-policy' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_company/jms-franchisee',
                name: 'jms-franchisee',
                meta: { title: '加盟商设置', authority: 'mjstore_company/jms-franchisee' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/jms-producttype',
                name: 'jms-producttype',
                meta: { title: '加盟产品分类', authority: 'mjstore_baseinfo/jms-producttype' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/jms-product',
                name: 'jms-product',
                meta: { title: '加盟报价', authority: 'mjstore_baseinfo/jms-product' },
                component: h(RouteView, {}, () => h(page_model)),
              },
            ],
          },
          {
            path: '/business_manage/mjstock_status',
            name: 'mjstock_status',
            meta: { title: '库存管理', authority: 'business_manage/mjstock_status' },
            component: RouteView2,
            redirect: '/business_manage/mjstore-customer',
            children: [
              {
                path: '/mjstore_baseinfo/mjstock-productcompany',
                name: 'mjstock-productcompany',
                meta: { title: '厂商管理', authority: 'mjstore_baseinfo/mjstock-productcompany' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstock-supplycompany',
                name: 'mjstock-supplycompany',
                meta: { title: '供应商管理', authority: 'mjstore_baseinfo/mjstock-supplycompany' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstock-sproducttype',
                name: 'mjstock-sproducttype',
                meta: { title: '库存品类分类', authority: 'mjstore_baseinfo/mjstock-sproducttype' },
                component: h(RouteView, {}, () => h(page_model)),
              },
              {
                path: '/mjstore_baseinfo/mjstock-sproduct',
                name: 'mjstock-sproduct',
                meta: { title: '库存品类', authority: 'mjstore_baseinfo/mjstock-sproduct' },
                component: h(RouteView, {}, () => h(page_model)),
              },
            ],
          },
        ],
      },
      {
        path: '/permission/apiurl-manage',
        name: 'mjstore-pricechangerecord',
        meta: { title: '接口管理', hideInMenu: true },
        component: (): Component => import('@/views/permission/apiurl-manage/index.vue'),
        redirect: '/permission/apiurl-manage/index-1',
        children: [
          {
            path: '/permission/apiurl-manage/index-1',
            name: 'apiurl-manage-1',
            meta: {
              title: '接口管理',

              hideInMenu: true,
            },
            component: () => import('@/views/permission/apiurl-manage/index-1.vue'),
          },
          {
            path: '/permission/apiurl-manage/index-2',
            name: 'apiurl-manage-2',
            meta: {
              title: '未绑定菜单的接口',

              hideInMenu: true,
            },
            component: () => import('@/views/permission/apiurl-manage/index-2.vue'),
          },
        ],
      },
      {
        path: '/business_manage/profile/basic/:id/:name',
        name: 'profile/basic',
        meta: { title: '客户详情页', hideInMenu: true },
        component: h(RouteView, {}, () => h(basic)),
      },
      {
        path: '/business_manage/profile/basic_order/:id/:name',
        name: 'profile/basic_order',
        meta: { title: '日预约', hideInMenu: true },
        component: h(RouteView, {}, () => h(basic_order)),
      },
      {
        path: '/business_manage/profile/basic-franchisee/:id/:name',
        name: 'profile/basic-franchisee',
        meta: { title: '加盟商详情页', hideInMenu: true },
        component: h(RouteView, {}, () => h(franchisee)),
      },
    ],
  },
];

export const staticRoutes: MenuDataItem[] = [
  {
    path: '/user',
    name: 'user',
    meta: { hideInMenu: true, title: 'pages.layouts.userLayout.title' },
    component: UserLayout2,
    children: [
      {
        path: '/user/login',
        name: 'login',
        meta: { title: 'pages.login.accountLogin.tab' },
        component: () => import('@/views/user/login.vue'),
      },
      {
        path: '/user/register',
        name: 'register',
        meta: { title: 'pages.login.registerAccount' },
        component: () => import('@/views/user/register.vue'),
      },
      {
        path: '/user/register-result',
        name: 'register-result',
        meta: { title: 'pages.login.registerAccount' },
        component: () => import('@/views/user/register-result.vue'),
      },
    ],
  },
  {
    path: '/other',
    name: 'other',
    meta: { hideInMenu: true, title: 'pages.layouts.userLayout.title' },
    component: OtherLayout,
    children: [
      {
        path: '/other/download',
        name: 'download',
        meta: { title: 'pages.login.accountLogin.tab' },
        component: () => import('@/views/other/download.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)',
    component: () => import('@/views/exception/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH),
  routes: staticRoutes,
});

export default router;
